import {utils_tool} from '@/tool';
import React from 'react'
import moment from "moment";

let {$$, checkStrLength} = utils_tool;

//配置项
let componentName = 'userMerge'


const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "账号",
    name: "userNameSearch",
    searchItem: {}
  },
  {
    title: "账号",
    name: "userName",
    formItem: {
      maxLength: 36,
      placeholder:"请输入账号",
      rules: [{
        required: true,
        message: '请输入账号',
      }
      ]
    },
    tableItem: {
      width: 200
    }
  },
  {
    title: "身份证号码",
    name: "idCardSearch",
    searchItem: {}
  },
  {
    title: "身份证号码",
    name: "idCard",
    formItem: {
      maxLength: 36,
      placeholder:"请输入身份证号码",
      rules: [{
        required: true,
        message: '请输入身份证号码',
      }
      ]
    },
    tableItem: {
      width: 200
    }
  },
  {
    title: "数据最新操作类型",
    name: "type",
    dataIndex: "type",
    dict: [
      {code: 0, codeName: "同步账号合并前基础数据处理"},
      // {code: 1, codeName: "同步账号合并前复杂数据处理"},
      {code: 2, codeName: "系统来源账号禁用身份证处理"},
    ],
    tableItem: {
      width: 250
    },
    searchItem: {
      type: "select",
    },
  },
  {
    title: '数据最新操作时间',
    name: 'updateTime',
    tableItem: {
      render: (text, record) => {
        return formatterDateTime(text)
      }
    }
  }
];

const templateConfig = (data) => {
  const { _this} = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          dataFormat: (val) => {
            return val
          },
          collapse: false,
          buttonSort: ['add'],
          buttons: [
            // {
            //   key: 'add',
            //   custom: true,
            //   params: { icon: 'plus', children: '新增', type: 'primary' },
            //   customOnClick: {
            //     key: 'jumpPage',
            //     params: {
            //       key: 'push',
            //       pathname: '/biz/surveyTemplate/surveyTemplateDetailAdd'
            //     }
            //   }
            // },
            // {
            //   key: "add",
            //   custom: true,
            //   params: { icon: "plus", type: 'primary', children: "新增处理数据" },
            //   customOnClick: {
            //     key: "modal",
            //     params: {
            //       apiKey: "saveOrUpdateUserMerge",
            //       apiParams: {},
            //       modalParams: {
            //         title: "新增处理数据",
            //         children: "Bla bla .."
            //       }
            //     }
            //   }
            // },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          isScroll: true,
          loading: false,
        },
        rowOperateSort:['update'],
        rowOperateView: [],
        commonOperate: {
          add: true,
          update:true
        }
      }
    }
  };
};

const apis = {
  list: {
    path: `${componentName}/pageList`,
    payload: {
      key: `${componentName}@pageList`,
      apiParams: {pageNum: 1, pageSize: 10}
    }
  },
  add: {
    path: `${componentName}/saveOrUpdateUserMerge`,
    payload: {
      key: `${componentName}@saveOrUpdateUserMerge1`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/saveOrUpdateUserMerge`,
    payload: {
      key: `${componentName}@saveOrUpdateUserMerge2`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
